export default __webpack_public_path__ + "static/media/innovativeIcon.487bbeb4.png";